/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container } from "@mui/material";

import SEO from "../components/common/seo";
import { MaintenanceContent } from "../components/container/login/content-maintenance";

export function Maintenance() {
  return (
    <>
      <SEO />
      <Container maxWidth={false} disableGutters>
        <MaintenanceContent />
      </Container>
    </>
  );
}
